/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Streaming_MinutesInputs */



/**
* | output |
* | --- |
* | "streaming minutes" |
*
* @param {Perks_Unit_Streaming_MinutesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_streaming_minutes = /** @type {((inputs?: Perks_Unit_Streaming_MinutesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Streaming_MinutesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("минут трансляции")
	return /** @type {LocalizedString} */ ("streaming minutes")
});